import { forwardRef } from 'react'
import {
  Popover as BasePopover,
  type PopoverProps as BasePopoverProps,
} from '../..//Popover'
import { Box } from '../../Box'

type PopoverProps = Omit<BasePopoverProps, 'minWidth' | 'maxHeight'> & {
  minWidth?: number
  maxHeight?: number
}

/** @deprecated */
export const Popover = forwardRef<HTMLElement, PopoverProps>(function Popover(
  { children, minWidth, maxHeight = 300, ...props },
  ref,
) {
  return (
    <BasePopover {...props} ref={ref} hideArrow style={{ minWidth }}>
      <Box padding="1x">{children}</Box>
    </BasePopover>
  )
})
